import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Mover from '../../../../../utils/Mover';
import SceneVideo from '../SceneVideo/SceneVideo';
import { MOVE_SCENE_Y, MOVE_Y } from '../../../../../constants';
import { setSceneVideo, soundBlocked } from '../../../../../redux/actions';
import SceneSpotGroup from '../../../../Shared/SceneSpotGroup/SceneSpotGroup';
import * as SoundManager from '../../../../../utils/SoundManager';
import * as Features from '../../../../../utils/Features';
import './SceneTop.css';
import TopBg from './TopBg/TopBg';
import TopMine from './TopMine/TopMine';
import TopSmokeContainer from './TopSmoke/TopSmokeContainer';

// note - there is duplicate code in top/bottom scene (maybe merge)

class SceneTop extends Component {
  constructor(props) {
    super(props);

    // ref
    this.sceneRef = React.createRef();

    // bind
    this.loop = this.loop.bind(this);
    this.handleSceneClick = this.handleSceneClick.bind(this);
  }

  // -------------------------------------------------------
  // Lifecycle
  // -------------------------------------------------------

  componentDidMount() {
    this.startLoop();
  }

  componentWillUnmount() {
    this.stopLoop();
  }

  // -------------------------------------------------------
  // Loop
  // -------------------------------------------------------

  loop() {
    const transY = Math.max(
      -(this.props.height * MOVE_Y * MOVE_SCENE_Y),
      -(Mover.getCenterOffsetY() * MOVE_SCENE_Y)
    );
    this.sceneRef.current.style.transform = `translateY(${transY}px)`;
    this.loopRef = window.requestAnimationFrame(this.loop);
  }

  startLoop() {
    if (!Features.features.mobile && !this.loopRef) {
      this.loopRef = window.requestAnimationFrame(this.loop);
    }
  }

  stopLoop() {
    window.cancelAnimationFrame(this.loopRef);
  }

  // -------------------------------------------------------
  // Click
  // -------------------------------------------------------

  handleSceneClick() {
    this.props.setSceneVideo('');
    // try to unmute sound
    if (this.props.sceneVideo === '' && this.props.soundBlockState === true) {
      this.props.soundBlocked(SoundManager.muteAtmo(false));
    }
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const {
      posX,
      scale,
      width,
      height,
      sceneVideo,
      sceneVideoPosition,
    } = this.props;

    // video vars
    const videoActive = sceneVideo.length > 0 && sceneVideoPosition === 1;
    const videoSource = videoActive ? sceneVideo : '';

    const scaleStyle = {
      bottom: -height * MOVE_Y * MOVE_SCENE_Y,
      transform: `scale(${scale})`,
    };

    return (
      <div
        id="scene-top"
        style={{
          width: `${width}px`,
          height: `${height}px`,
        }}
      >
        <div
          className="scene-content"
          ref={this.sceneRef}
          onClick={this.handleSceneClick}
        >
          <div className="scene-wrap" style={scaleStyle}>
            <div id="bg-top-wrap">
              <TopBg posX={posX} />
              <TopSmokeContainer posX={posX} />
              <TopMine posX={posX} />
            </div>
          </div>
          <SceneSpotGroup type={1} style={scaleStyle} />
        </div>
        <SceneVideo type="top" active={videoActive} source={videoSource} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  scale: state.ui.scale,
  width: state.ui.width,
  height: state.ui.height,
  sceneVideo: state.app.sceneVideo,
  sceneVideoPosition: state.app.sceneVideoPosition,
  soundBlockState: state.app.soundBlockState,
});

const mapDispatchToProps = dispatch => ({
  setSceneVideo: videoId => dispatch(setSceneVideo(videoId)),
  soundBlocked: soundBlockState => dispatch(soundBlocked(soundBlockState)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SceneTop);



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/SceneTop/SceneTop.js